import { createContext as K, useRef as q, createElement as I, useContext as J, useState as Q, useEffect as U } from "react";
import { useStore as P, useAtom as X, useAtomValue as Y, useSetAtom as Z, Provider as H } from "jotai/react";
import { useHydrateAtoms as l } from "jotai/react/utils";
import { createStore as k } from "jotai/vanilla";
import { useHydrateAtoms as B } from "jotai/utils";
import { atom as ee } from "jotai";
import { INTERNAL_getBuildingBlocksRev2 as te, INTERNAL_buildStoreRev2 as ne } from "jotai/vanilla/internals";
function pe() {
  const d = K(null);
  function m({
    store: a,
    initialValues: S = [],
    children: p
  }) {
    const y = q(a);
    return y.current || (y.current = k()), l(S, { store: y.current }), I(d.Provider, {
      value: y.current,
      children: p
    });
  }
  const h = (a) => {
    const S = J(d);
    if (!S) throw new Error("Missing Provider from createIsolation");
    return P({ store: S, ...a });
  };
  return { Provider: m, useStore: h, useAtom: (a, S) => {
    const p = h();
    return X(a, { store: p, ...S });
  }, useAtomValue: (a, S) => {
    const p = h();
    return Y(a, { store: p, ...S });
  }, useSetAtom: (a, S) => {
    const p = h();
    return Z(a, { store: p, ...S });
  } };
}
const $ = /* @__PURE__ */ new WeakMap();
function V(d, m) {
  const h = new Set(d), v = new Set(m);
  return d === m || h.size === v.size && Array.from(h).every(v.has.bind(v));
}
function T() {
  return this.name;
}
function _(d) {
  return "write" in d;
}
const L = process.env.NODE_ENV !== "production", G = {};
L && (G.name = "unscoped", G.toString = T);
function re({
  atoms: d = [],
  atomFamilies: m = [],
  parentStore: h,
  name: v
}) {
  const M = new Set(d), A = new Set(m), a = $.get(h), S = (a == null ? void 0 : a.baseStore) ?? h, p = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), c = {
    getAtom: w,
    baseStore: S,
    cleanup() {
      for (const t of g)
        t();
    },
    prepareWriteAtom(t, r, n, s) {
      if (r.read === C && _(r) && _(t) && r.write !== D && c !== n) {
        const { write: f } = r;
        return t.write = u(
          r.write.bind(
            r
          ),
          n,
          s
        ), () => {
          t.write = f;
        };
      }
    }
  }, i = oe(c);
  $.set(i, c), v && L && (c.name = v, c.toString = T);
  for (const t of M)
    p.set(t, [e(t, c), c]);
  const g = /* @__PURE__ */ new Set();
  for (const t of A) {
    for (const n of t.getParams()) {
      const s = t(n);
      p.has(s) || p.set(s, [e(s, c), c]);
    }
    const r = t.unstable_listen((n) => {
      n.type === "CREATE" && !p.has(n.atom) ? p.set(n.atom, [e(n.atom, c), c]) : M.has(n.atom) || p.delete(n.atom);
    });
    g.add(r);
  }
  return i;
  function w(t, r) {
    var s, f;
    if (p.has(t))
      return p.get(t);
    if (r === c)
      return y.has(t) || y.set(t, [e(t, r), r]), y.get(t);
    const n = r ?? G;
    if (a) {
      if (!((s = E.get(n)) != null && s.has(t))) {
        const [W, F] = a.getAtom(
          t,
          r
        );
        b(
          O(W, t, F),
          t,
          r,
          F
        );
      }
      return E.get(n).get(t);
    }
    return (f = E.get(n)) != null && f.has(t) || b(O(t, t), t), E.get(n).get(t);
  }
  function b(t, r, n, s) {
    const f = n ?? G;
    E.has(f) || E.set(f, /* @__PURE__ */ new WeakMap()), E.get(f).set(
      r,
      [
        t,
        //
        s
      ].filter(Boolean)
    );
  }
  function O(t, r, n) {
    return r.read !== C ? e(r, n) : t;
  }
  function e(t, r) {
    const n = Object.getOwnPropertyDescriptors(t);
    Object.keys(n).filter((W) => ["read", "write", "debugLabel"].includes(W)).forEach((W) => n[W].configurable = !0);
    const s = Object.getPrototypeOf(t), f = Object.create(s, n);
    return f.originalAtom = t, f.read !== C && (f.read = o(
      t.read.bind(t),
      r
    )), _(f) && _(t) && f.write !== D && (f.write = u(
      t.write.bind(t),
      r
    )), L && Object.defineProperty(f, "debugLabel", {
      get() {
        return `${t.debugLabel}@${c.name}`;
      },
      configurable: !0,
      enumerable: !0
    }), f;
  }
  function o(t, r) {
    return function(s, f) {
      return t(
        function(F) {
          const [j] = w(F, r);
          return s(j);
        },
        //
        f
      );
    };
  }
  function u(t, r, n = r) {
    return function(f, W, ...F) {
      return t(
        function(R) {
          const [x] = w(R, r);
          return f(x);
        },
        function(R, ...x) {
          const [N] = w(R, r), z = c.prepareWriteAtom(
            N,
            R,
            r,
            n
          );
          try {
            return W(N, ...x);
          } finally {
            z == null || z();
          }
        },
        ...F
      );
    };
  }
}
const { read: C, write: D } = ee(null);
function oe(d) {
  const m = [...te(d.baseStore)], h = m[21], v = m[22], M = m[23], A = {};
  m[9] = (e, o) => {
    var u;
    return (u = o.unstable_onInit) == null ? void 0 : u.call(o, a);
  }, m[21] = i(h), m[22] = E, m[23] = i(M), m[24] = ([...e]) => {
    const o = [
      g(e[0], S),
      // atomStateMap
      g(e[1], p),
      // mountedMap
      g(e[2]),
      // invalidatedAtoms
      w(e[3]),
      // changedAtoms
      e[4],
      // mountCallbacks
      e[5],
      // unmountCallbacks
      O(e[6]),
      // storeHooks
      i(e[7]),
      // atomRead
      i(e[8]),
      // atomWrite
      e[9],
      // atomOnInit
      i(e[10]),
      // atomOnMount
      i(
        e[11],
        // ensureAtomState
        (u) => y(o[0], u)
      ),
      e[12],
      // flushCallbacks
      e[13],
      // recomputeInvalidatedAtoms
      i(e[14]),
      // readAtomState
      i(e[15]),
      // invalidateDependents
      i(e[16]),
      // writeAtomState
      i(e[17]),
      // mountDependencies
      i(e[18]),
      // mountAtom
      i(e[19]),
      // unmountAtom
      i(e[20]),
      // setAtomStateValueOrPromise
      i(e[21]),
      // getAtom
      i(e[22]),
      // setAtom
      i(e[23]),
      // subAtom
      void 0
      // enhanceBuildingBlocks
    ];
    return o;
  };
  const a = ne(...m);
  return a;
  function S(e) {
    const o = /* @__PURE__ */ new WeakMap();
    return function(t) {
      let r = o.get(t);
      if (r)
        return r;
      const n = e(t);
      if (n)
        return r = {
          ...n,
          d: g(n.d, function(f) {
            return (W) => f(d.getAtom(W)[0]);
          }),
          p: w(n.p),
          get n() {
            return n.n;
          },
          set n(s) {
            n.n = s;
          },
          get v() {
            return n.v;
          },
          set v(s) {
            n.v = s;
          },
          get e() {
            return n.e;
          },
          set e(s) {
            n.e = s;
          }
        }, o.set(t, r), r;
    };
  }
  function p(e) {
    const o = /* @__PURE__ */ new WeakMap();
    return function(t) {
      let r = o.get(t);
      if (r)
        return r;
      const n = e(t);
      if (n)
        return r = {
          ...n,
          d: w(n.d),
          t: w(n.t),
          get u() {
            return n.u;
          },
          set u(s) {
            n.u = s;
          }
        }, o.set(t, r), n;
    };
  }
  function y(e, o) {
    return function(t, r) {
      const n = e.get(r);
      return n || (e.set(r, o(t, r)), e.get(r));
    };
  }
  function E(e, o, ...u) {
    const [t, r] = d.getAtom(o), n = d.prepareWriteAtom(
      t,
      o,
      r,
      d
    );
    try {
      return v(e, t, ...u);
    } finally {
      n == null || n();
    }
  }
  function c(e, o) {
    return function(t, ...r) {
      const [n] = d.getAtom(t);
      return (o ? o(e) : e)(n, ...r);
    };
  }
  function i(e, o) {
    return function(t, r, ...n) {
      const [s] = d.getAtom(r);
      return (o ? o(e) : e)(t, s, ...n);
    };
  }
  function g(e, o) {
    const u = {
      get: c(e.get.bind(e), o),
      set: c(e.set.bind(e))
    };
    return "has" in e && (u.has = c(e.has.bind(e))), "delete" in e && (u.delete = c(e.delete.bind(e))), u;
  }
  function w(e) {
    return {
      get size() {
        return e.size;
      },
      add: c(e.add.bind(e)),
      has: c(e.has.bind(e)),
      clear: e.clear.bind(e),
      forEach: (o) => e.forEach(c(o)),
      *[Symbol.iterator]() {
        for (const o of e) yield d.getAtom(o)[0];
      }
    };
  }
  function b(e) {
    if (!e)
      return;
    const o = c(e);
    return o.add = function(t, r) {
      if (t === void 0)
        return e.add(void 0, r);
      const [n] = d.getAtom(t);
      return e.add(n, r);
    }, o;
  }
  function O(e) {
    return Object.assign({
      get r() {
        return A.r ?? (A.r = b(e.r));
      },
      set r(u) {
        e.r = u;
      },
      get c() {
        return A.c ?? (A.c = b(e.c));
      },
      set c(u) {
        e.c = u;
      },
      get m() {
        return A.m ?? (A.m = b(e.m));
      },
      set m(u) {
        e.m = u;
      },
      get u() {
        return A.u ?? (A.u = b(e.u));
      },
      set u(u) {
        e.u = u;
      },
      get f() {
        return e.f;
      },
      set f(u) {
        e.f = u;
      }
    }, e);
  }
}
function me(d) {
  var i;
  const {
    atoms: m = [],
    atomFamilies: h = [],
    children: v,
    scope: M,
    name: A
  } = d, a = P(), S = Array.from(m, (g) => Array.isArray(g) ? g[0] : g);
  function p() {
    return [
      M ?? re({ atoms: S, atomFamilies: h, parentStore: a, name: A }),
      function(w) {
        return a !== w.parentStore || !V(S, w.atoms) || !V(h, w.atomFamilies) || M !== w.providedScope;
      }
    ];
  }
  const [[y, E], c] = Q(p);
  return E({ atoms: S, atomFamilies: h, parentStore: a, providedScope: M }) && ((i = $.get(y)) == null || i.cleanup(), c(p)), B(
    Array.from(m).filter(Array.isArray),
    { store: y }
  ), U(() => {
    var g;
    return (g = $.get(y)) == null ? void 0 : g.cleanup;
  }, [y]), I(H, { store: y }, v);
}
export {
  me as ScopeProvider,
  pe as createIsolation,
  re as createScope
};
//# sourceMappingURL=index.mjs.map
